import { alpha } from '@mui/material/styles';
import { Z_INDEX } from '../../constants/zIndex';

// ----------------------------------------------------------------------

export default function Pickers(theme) {
  return {
    PrivatePickersPopper: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z24,
          borderRadius: theme.shape.borderRadiusMd,
          zIndex: Z_INDEX.HEADER_DROPDOWN, // Ensure date picker popup appears above other elements
        },
      },
    },

    PrivatePicker: {
      styleOverrides: {
        root: {
          overflow: 'hidden',
          borderRadius: theme.shape.borderRadiusMd,
          '& .PrivatePickersToolbar-root': {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            '& .MuiTypography-root': {
              color: alpha(theme.palette.common.white, 0.72),
              '&.Mui-selected': {
                color: theme.palette.common.white,
              },
            },
          },
          '& .MuiTab-root': {
            margin: 0,
            color: alpha(theme.palette.common.white, 0.72),
            '&.Mui-selected': {
              color: theme.palette.common.white,
            },
          },
          '& .MuiTabs-indicator': {
            width: '160px !important',
            backgroundColor: theme.palette.primary.dark,
          },
        },
        landscape: {
          border: `solid 1px ${theme.palette.divider}`,
        },
      },
    },

    MuiDateRangePickerViewDesktop: {
      styleOverrides: {
        root: {
          border: `solid 1px ${theme.palette.divider}`,
          borderRadius: theme.shape.borderRadiusMd,
        },
      },
    },

    // Additional overrides for newer MUI X Date Pickers
    MuiPickersPopper: {
      styleOverrides: {
        paper: {
          zIndex: Z_INDEX.HEADER_DROPDOWN, // Ensure all picker poppers appear above other elements
        },
      },
    },

    MuiDesktopDatePicker: {
      styleOverrides: {
        root: {
          '& .MuiPickersPopper-root': {
            zIndex: Z_INDEX.HEADER_DROPDOWN,
          },
        },
      },
    },

    // Ensure date picker popups appear above DocumentManagerV2 dialogs
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiPickersPopper-root': {
            zIndex: Z_INDEX.MAX, // Force date picker popups above dialogs
          },
          '& .PrivatePickersPopper-root': {
            zIndex: Z_INDEX.MAX, // Force legacy date picker popups above dialogs
          },
        },
      },
    },

    // Global overrides to ensure date picker popups always appear on top
    MuiPickersPopper: {
      styleOverrides: {
        root: {
          zIndex: Z_INDEX.MAX, // Ensure all picker poppers appear above everything
        },
        paper: {
          zIndex: Z_INDEX.MAX, // Ensure all picker popper papers appear above everything
        },
      },
    },

    PrivatePickersPopper: {
      styleOverrides: {
        root: {
          zIndex: Z_INDEX.MAX, // Ensure legacy picker poppers appear above everything
        },
        paper: {
          zIndex: Z_INDEX.MAX, // Ensure legacy picker popper papers appear above everything
        },
      },
    },
  };
}
